import styled from 'styled-components';

export const UCPListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const BreadCrumbContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.family.inter};
  gap: 8px;
`;

export const Content = styled.div`
  flex: 1;
  padding: 0 24px 24px 24px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

export const NoDataTitle = styled.h3`
  margin: 24px 0 12px 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const NoDataDescription = styled.p`
  margin: 0;
  font-size: 16px;
  color: #666;
  max-width: 400px;
  line-height: 1.5;
`;

export const TableContainer = styled.div`
  margin-top: 24px;
  position: relative;
  max-height: calc(100vh - 400px);
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export const NameWithVisibilityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  .gray-icon img {
    filter: grayscale(100%) brightness(0.6);
  }
`;

export const UnderlinedText = styled.span`
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-thickness: 1px;
`; 

export const NameWithVisibilityIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;  
`;